import { Component } from "@angular/core";
import { Train, Site, Customer, NavEntity } from "../../models";
import { Subscription } from "rxjs";
import { StarmsClientProvider } from "../../providers/starms-client/starms-client";
import { NavParams } from "ionic-angular";

@Component({
  selector: "train-instrument-health",
  templateUrl: "train-instrument-health.html",
})
export class TrainInstrumentHealthComponent {
  nav: NavEntity;
  productLine: string;
  isAGT: boolean;
  ready: boolean;
  current: Site | Customer | Train;
  trainId: number;
  subscription: Subscription;
  subscription2: Subscription;
  equipmentList: Array<any> = [];
  equipmentReady = false;
  constructor(
    private starmsClientService: StarmsClientProvider,
    public navParams: NavParams
  ) {}

  ionViewDidLoad() {
    this.nav = this.navParams.data;
    this.ready = false;
    this.getProductLine();
  }

  getProductLine(): void {
    this.subscription2 = this.starmsClientService
      .get([this.nav.getType() + "s", this.nav.getId()])
      .subscribe((value) => {
        if (value !== undefined && value !== null) {
          const trainDeserialized = new Train().deserialize(value);

          this.productLine = trainDeserialized.assignedPL;

          if (this.productLine === "AGT") {
            this.isAGT = true;
          } else {
            this.isAGT = false;
          }

          this.ready = true;
        }
      });
  }
  openEquipmentDetails(eq: any) {}
}



// WEBPACK FOOTER //
// ./src/components/train-instrument-health/train-instrument-health.ts